import { schema, types } from 'papr'

export const teamPublicationUserInviteSchema = schema(
	{
		publication: types.objectId({ required: true }),
		invitedEmail: types.string({ required: true }),
		invitedUser: types.objectId(),
		invitedBy: types.objectId({ required: true }),
		role: types.enum(['contributor' as const, 'admin' as const], {
			required: true,
		}),
		status: types.enum(
			['pending' as const, 'accepted' as const, 'declined' as const, 'revoked' as const],
			{
				required: true,
			},
		),
		dateInvited: types.date({ required: true }),
		inviteToken: types.string({ required: true }),
	},
	{
		timestamps: true,
	},
)

export type TeamPublicationUserInviteDocument = (typeof teamPublicationUserInviteSchema)[0]
export type teamPublicationUserInviteDefaults = (typeof teamPublicationUserInviteSchema)[1]
